export enum TabFullScreenEnum {
  NONE,
  DETAIL,
  EXTRACT,
}

export enum TabEnum {
  SIMULATION,
  YOUR_LOANS,
}
